import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import Base from "../../../Common/Components/Base";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  makeStyles,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles({
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: 400,
    background: "cyan",
    color: "black",
  },
  button: {
    color: "white",
    justifyContent: "center",
    display: "flex",
  },
});

const StudentHalfDone = ({ data }) => {
  const history = useHistory();

  const onClick = () => {
    history.push({
      pathname: "/dashboard/s-booking/halfDone",
    });
  };

  const classes = useStyles();

  return (
    <div onClick={() => onClick()} style={{ cursor: "pointer" }}>
      <Card variant="contained" className={classes.card}>
        <CardContent>
          <>
            <Typography>Half Done</Typography>
            <Typography variant="h2" align="center">
              {data.halfDone}
            </Typography>
          </>
        </CardContent>
      </Card>
    </div>
  );
};

export default StudentHalfDone;
